import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import PropTypes from "prop-types";
import "./Navbar.css";
import Thermometer from "../Thermometer/Thermometer";
import { t } from "@lingui/macro";

const Navbar = ({ onLogout, setLocale }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isThermometerVisible, setIsThermometerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const navigate = useNavigate();
  const { isLoggedIn, userRole } = useAuth();

  const handleLogout = () => {
    onLogout();
    navigate("/");
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMouseEnter = () => {
    setIsThermometerVisible(true);
  };

  const handleMouseLeave = () => {
    setIsThermometerVisible(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderNavLinks = () => {
    const navLinks = {
      notLoggedIn: [
        { label: t`Rooms`, path: "/book-room" },
        { label: t`Tickets`, path: "/buy-tickets" },
      ],
      ROLE_CLIENT: [
        { label: t`Rooms`, path: "/book-room" },
        { label: t`Tickets`, path: "/buy-tickets" },
        { label: t`My Account`, path: "/account" },
      ],
      ROLE_WORKER: [
        { label: t`Sell Tickets`, path: "/sell-tickets" },
        { label: t`Check Ticket`, path: "/check-ticket" },
        { label: t`Reservations`, path: "/reservations" },
        { label: t`My Account`, path: "/account" },
      ],
      ROLE_MANAGER: [
        { label: t`Dashboard`, path: "/dashboard" },
        { label: t`Sell Tickets`, path: "/sell-tickets" },
        { label: t`Check Ticket`, path: "/check-ticket" },
        { label: t`Rooms`, path: "/book-room" },
        { label: t`Reservations`, path: "/reservations" },
        { label: t`My Account`, path: "/account" },
      ],
    };

    const links = navLinks[userRole] || navLinks.notLoggedIn;

    return links.map((link, index) => (
      <li key={index} className="nav-item">
        <Link
          className="nav-link"
          to={link.path}
          onClick={() => setIsMenuOpen(false)}
        >
          {link.label}
        </Link>
      </li>
    ));
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-custom">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          <div
            className="logo-container"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <img
              src={"../assets/images/logo/ElArenal.svg"}
              alt="Aquapark"
              className="logo"
            />
            {isThermometerVisible && <Thermometer />}
          </div>
        </Link>

        {/* Language buttons – mobile */}
        {isMobile && (
          <div className="language-buttons-mobile">
           <button
  onClick={() => {
    console.log("🇬🇧 Click EN");
    setLocale("en");
  }}
  className="language-button"
>
  🇬🇧
</button>

<button
  onClick={() => {
    console.log("🇪🇸 Click ES");
    setLocale("es");
  }}
  className="language-button"
>
  🇪🇸
</button>
          </div>
        )}

        {isMobile && (
          <div className="menu-icon" onClick={toggleMenu}>
            &#9776;
          </div>
        )}

        {isMobile ? (
          <div
            className={`navbar-collapse ${isMenuOpen ? "active" : ""}`}
            id="navbarNav"
          >
            <ul className="navbar-nav">
              {renderNavLinks()}
              <li className="nav-item">
                {!isLoggedIn ? (
                  <>
                    <Link
                      className="nav-link"
                      to="/login"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {t`Login`}
                    </Link>
                    <Link
                      className="nav-link"
                      to="/register"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {t`Register`}
                    </Link>
                  </>
                ) : (
                  <div className="user-info">
                    <button
                      className="btn-outline-danger"
                      onClick={handleLogout}
                    >
                      {t`Logout`}
                    </button>
                  </div>
                )}
              </li>
            </ul>
          </div>
        ) : (
          <div className="navbar-collapse">
            <div className="navbar-nav-left">
              <ul className="navbar-nav">{renderNavLinks()}</ul>
            </div>

            <div className="navbar-nav-right">
              {!isLoggedIn ? (
                <>
                  <Link className="nav-link" to="/login">
                    {t`Login`}
                  </Link>
                  <Link className="nav-link" to="/register">
                    {t`Register`}
                  </Link>
                </>
              ) : (
                <div className="user-info">
                  <button className="add-new-btn" onClick={handleLogout}>
                    {t`Logout`}
                  </button>
                </div>
              )}
            </div>

            {/* Language buttons – desktop */}
            <div className="language-buttons">
              <button
  type="button"
  onClick={(e) => {
    e.stopPropagation();
    console.log("🖱️ Desktop EN");
    setLocale("en");
  }}
  className="language-button"
>
  <img src="/assets/images/flags/us.png" alt="English" />
</button>

<button
  type="button"
  onClick={(e) => {
    e.stopPropagation();
    console.log("🖱️ Desktop ES");
    setLocale("es");
  }}
  className="language-button"
>
  <img src="/assets/images/flags/mx.png" alt="Español" />
</button>

            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

Navbar.propTypes = {
  onLogout: PropTypes.func.isRequired,
  setLocale: PropTypes.func.isRequired,
};

export default Navbar;
